module.exports = (SalonService, RESTService) ->
  'ngInject'
  {
    service: (salonId) ->
      RESTService.service('transfer_information', SalonService.one(salonId))
  }
